import { ShieldCheck, FileText, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

const CERTIFICATE_URL =
  "https://customer-assets.emergentagent.com/job_soccer-academy-43/artifacts/kd9evc8d_STARS%20OF%20MPUMALANGA%20_Certificate.pdf";

export default function Credentials() {
  return (
    <section
      id="credentials"
      data-testid="credentials-section"
      className="relative px-6 lg:px-10 py-12 lg:py-16 bg-[#0a0a0a]"
    >
      <div className="max-w-7xl mx-auto">
        <div
          className="relative overflow-hidden rounded-2xl border border-red-600/20 bg-gradient-to-br from-red-950/40 via-neutral-950 to-neutral-950 p-6 lg:p-10 fade-up"
        >
          {/* Decorative shield watermark */}
          <ShieldCheck
            className="absolute -right-6 -bottom-6 h-48 w-48 text-red-600/5"
            strokeWidth={1}
          />

          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-center">
            <div className="lg:col-span-2 flex lg:justify-center">
              <span className="inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-red-600/10 border border-red-600/30 text-red-600">
                <ShieldCheck className="h-8 w-8" strokeWidth={1.8} />
              </span>
            </div>

            <div className="lg:col-span-6">
              <p className="text-[10px] uppercase tracking-[0.3em] text-red-600 mb-2">
                Officially Registered
              </p>
              <h3 className="font-heading uppercase text-2xl lg:text-3xl tracking-tight leading-none mb-3">
                Stars of Mpumalanga is a registered soccer academy.
              </h3>
              <p className="text-sm text-white/60 leading-relaxed max-w-xl">
                Operating with proper credentials and accountability since 2022
                — your child is in the right hands. View our official
                registration certificate below.
              </p>
            </div>

            <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-3 lg:items-end">
              <Button
                asChild
                data-testid="view-certificate-button"
                className="bg-red-600 hover:bg-red-500 text-white font-heading uppercase tracking-widest rounded-full px-6 h-12 text-xs"
              >
                <a
                  href={CERTIFICATE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FileText className="h-4 w-4 mr-2" />
                  View Certificate
                  <ExternalLink className="h-3.5 w-3.5 ml-2" />
                </a>
              </Button>
              <Button
                asChild
                variant="outline"
                data-testid="download-certificate-button"
                className="bg-transparent border-white/15 text-white hover:bg-white/5 hover:text-red-600 font-heading uppercase tracking-widest rounded-full px-6 h-12 text-xs"
              >
                <a
                  href={CERTIFICATE_URL}
                  download="Stars-of-Mpumalanga-Certificate.pdf"
                >
                  Download PDF
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
